import { effects as connectionsEffects } from './connections';
import { effects as vippsEffects } from './vipps';
import { effects as vippsCallbackEffects } from './vippsCallback';
import { effects as instabankEffects } from './instabank';
import { effects as payexEffects } from './payex';
import { effects as payexCallbackEffects } from './payexCallback';
import { effects as swishEffects } from './swish';
import { effects as swishCallbackEffects } from './swishCallback';
import { effects as bamboraCallbackEffects } from './bamboraCallback';

const effects = {
    ...connectionsEffects,
    ...vippsEffects,
    ...vippsCallbackEffects,
    ...instabankEffects,
    ...payexEffects,
    ...payexCallbackEffects,
    ...swishEffects,
    ...swishCallbackEffects,
    ...bamboraCallbackEffects,
};

export default effects;
